import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../utils/AuthContext";
import LoginModal from "./LoginModal";
import SearchBar from "./SearchBar";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const timeoutRef = useRef(null);
  const { user, isAuthenticated, logout } = useAuth();

  useEffect(() => {
    const handleShowLoginModal = () => {
      setShowLoginModal(true);
    };

    window.addEventListener('showLoginModal', handleShowLoginModal);

    return () => {
      window.removeEventListener('showLoginModal', handleShowLoginModal);
    };
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setShowMenu(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowMenu(false);
    }, 150);
  };

  const handleMyGamesClick = (e) => {
    if (!isAuthenticated) {
      e.preventDefault();
      setShowLoginModal(true);
    }
  };

  const handleLoginSuccess = () => {
    // Navigate to My Games after successful login
    navigate('/my-games');
  };

  return (
    <nav className="bg-white text-gray-900 px-6 py-3 shadow-md">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <Link to="/">
            <img src="/OPGameTrackerLogo.png" alt="OP Game Tracker Logo" className="h-20 w-auto" />
          </Link>
          <span className="text-4xl font-bold hidden sm:inline">Game Tracker</span>
        </div>

        {/* Search Bar */}
        <SearchBar />

        {/* Nav links */}
        <div className="flex items-center space-x-6 relative">
          <Link to="/calendar" className="hover:text-blue-400 hidden md:inline">Calendar</Link>
          <Link to="/tracker-game" className="hover:text-blue-400 hidden md:inline">Tracker Game</Link>
          <Link 
            to="/my-games" 
            className="hover:text-blue-400 hidden md:inline"
            onClick={handleMyGamesClick}
          >
            My Games
          </Link>

          {/* Profile dropdown */}
          {isAuthenticated && user ? (
            <div
              className="relative"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <button className="text-2xl hover:text-blue-600" title="Profile" aria-label="Profile">
                👤
              </button>
              {showMenu && (
                <div className="absolute right-0 mt-2 w-48 bg-white text-gray-900 rounded shadow z-50">
                  <Link
                    to="/profile"
                    className="block px-4 py-2 hover:bg-gray-100"
                    onClick={() => setShowMenu(false)}
                  >
                    Profile Dashboard
                  </Link>
                  <button
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-2 hover:bg-gray-100"
                  >
                    Log Out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button 
              onClick={() => setShowLoginModal(true)} 
              className="hover:text-blue-600 text-2xl" 
              title="Login"
            >
              👤
            </button>
          )}
        </div>
      </div>

      {/* Login Modal */}
      <LoginModal 
        isOpen={showLoginModal} 
        onClose={() => setShowLoginModal(false)}
        onLoginSuccess={handleLoginSuccess}
      />
    </nav>
  );
};

export default Navbar;
